export default __webpack_public_path__ + "static/media/e-market.c371ac79.svg";